export default __webpack_public_path__ + "static/media/10.bfa74ef3.jpg";